<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <v-banner v-model="reloadDialog" single-line icon-color="green" icon="mdi-plus-circle">
        There is a newer version of the web portal available.
        <template v-slot:actions>
            <v-btn class="green white--text" @click="reloadPortal()">
                Reload
            </v-btn>
        </template>
    </v-banner>
</template>

<script>
    export default
    {
        name: 'portal-reload-dialog',
        data: function ()
        {
            return {
            }
        },
        props:
        {
            reloadDialog: Boolean(false)
        },
        methods:
        {
            reloadPortal()
            {
                window.location.reload(true)
            }
        }
    };
</script>

<style scoped>

</style>